module.exports = __webpack_public_path__ + "img/reflection.8372d759.png";